<div class="mb-4">
    <p-card *ngIf="product">
        <ng-template pTemplate="header">
            <div class="pr-4 pl-4 pt-4">
                <div class="flex mb-3">
                    <p-button label="Back" icon="pi pi-arrow-left" [text]="true" [plain]="true" (click)="goBack()"/>
                </div>
                <div class="flex">
                    <h5 class="black-font">{{product.ProductName}}</h5>
                </div>
                <div class="flex justify-content-between">
                    <div class="black-font">{{product.ProductId}}</div>
                    <div class="flex">
                        <!-- <p-button label="Release Security Bond" /> -->
                    </div>
                </div>
            </div>
        </ng-template>
        <hr class="delimiter">
        <div class="insights-upper-side flex flex-row">
            <div class="insights-left-block">
                <div class="section-header mb-1">Product Information:</div>
                <div class="flex mt-3">
                    <div class="flex-1">
                        <div class="sidebar-text sidebar-left-label mt-3">Date Availed:</div>
                        <div class="sidebar-text sidebar-left-label mt-3">Price:</div>
                    </div>
                    <div class="flex-1">
                        <div class="sidebar-text vehicle-list-val mt-3">{{product.DateAvailed | date: 'MMM dd, yyyy'}}</div>
                        <div class="sidebar-text vehicle-list-val mt-3">{{product.Amount | currency: 'PHP' : 'symbol' : '1.2-2'  }}</div>
                    </div>
                </div>

                <div class="section-header mb-3 mt-3">Product Images:</div>
                <p-carousel 
                    [value]="productImages" 
                    [numVisible]="1" 
                    [numScroll]="1" 
                    [circular]="false" 
                    [responsiveOptions]="responsiveOptions">
                        <ng-template let-image pTemplate="item">
                            <div class="border-1 surface-border border-round m-2 p-3">
                                <div class="mb-3">
                                    <div class="relative mx-auto text-center">
                                        <img 
                                            src="{{image}}" 
                                            class="w-10 border-round" />
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                </p-carousel>

                <div class="section-header mb-4">Agreement Document:</div>
                <div class="flex flex-row">
                    <div *ngFor="let image of productDocuments">
                         <img class="cursor-pointer mr-4" (click)="getSafeUrl(image)" src="XpressApp\assets\images\pdf-icon.png" width="80px" alt="file" />
                    </div>
                </div>
            </div>
    
            <div class="right-top-block customer-review">
                <div class="section-header ml-3 mt-3 mb-1">Product Terms:</div>
                <div class="flex mt-3 ml-3">
                    <div class="flex-1">
                        <div class="sidebar-text sidebar-left-label mt-3">Status:</div>
                        <div class="sidebar-text sidebar-left-label mt-3">Start Date:</div>
                        <div class="sidebar-text sidebar-left-label mt-3">Payment Period:</div>
                        <div class="sidebar-text sidebar-left-label mt-3">Terms:</div>
                        <div class="sidebar-text sidebar-left-label mt-3">Amount Repaid:</div>
                        <div class="sidebar-text sidebar-left-label mt-3">Balance:</div>
                    </div>
                    <div class="flex-1">
                        <div class="sidebar-text vehicle-list-val mt-3">{{getStatusText(product.Status)}}</div>
                        <div class="sidebar-text vehicle-list-val mt-3">{{product.StartDate | date: 'MMM dd, yyyy'}}</div>
                        <div class="sidebar-text vehicle-list-val mt-3">{{product.PaymentPeriod}} Months</div>
                        <div class="sidebar-text vehicle-list-val mt-3">{{(product.PaymentTerm | currency: 'PHP' : 'symbol' : '1.2-2') + ' ' + deductionFrequency[product.DeductionFrequency]}}</div>
                        <div class="sidebar-text vehicle-list-val mt-3">{{(product.AmountPaid | currency: 'PHP' : 'symbol' : '1.2-2') + ' (' + product.AmountPaidCount + ' of ' + product.StandardAging + ')'}}</div>
                        <div class="sidebar-text vehicle-list-val mt-3">{{product.Balance | currency: 'PHP' : 'symbol' : '1.2-2'}}</div>
                    </div>
                    <div class="flex-1">
                        <div class="mt-4 text-right mr-5">
                            <a class="cursor-pointer" target="_blank" (click)="showEditProduct()">Edit</a>
                        </div>
                    </div>
                </div>

                <div class="section-header ml-3 mt-3 mb-4">History</div>

                <div class="ml-3">
                    <p-table #xpressUsersGrid
                                [columns]="historyCols"
                                [value]="product.ChangeHistory"
                                [lazy]="true"
                                responsiveLayout="scroll" dataKey="Id"
                                [showFirstLastIcon]="false"
                                [resizableColumns]="true"
                                [columnResizeMode]="'expand'"
                                [autoLayout]="true"
                                [styleClass]="'p-datatable-gridlines'"
                                [scrollable]="true"
                                [scrollHeight]="'flex'"
                                [style]="{height: 'calc(40%)'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let col of historyCols"
                                    [pSortableColumn]="col.field"
                                    [pSortableColumnDisabled]="false"
                                    [style.width]="col.width">
                                    {{col.header}}
                                    <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-history let-rowIndex="rowIndex">
                            <tr> 
                                <td>
                                    <span>{{history.Date | date: 'MMM dd, yyyy'}}</span>
                                </td>
                                <td>
                                    <span class="status" [ngStyle]="getStatusStyles(history.Action)">{{commerceHistory[history.Action]}}</span>
                                </td>
                                <td>
                                    <span>{{history.Reason}}</span>
                                </td>
                                <td>
                                    <span>{{history.EditedBy}}</span>
                                </td>
                                <td>
                                    <span>{{history.Remarks ? history.Remarks : '-'}}</span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>   
            </div>
        </div>
    </p-card>
</div>

<!-- <product-transactions [showBack]="false"></product-transactions> -->

<!-- PDF Viewer -->
<p-dialog
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="hideDialog()"
    [style]="{height: '560px'}"
    [(visible)]="isPdfViewable">
    <ng-template pTemplate="body">
        <iframe class="mb-3" [src]="safeUrl" [style]="{ width: '500px', display: 'block', height: '511px'}"></iframe>
    </ng-template>
</p-dialog>

<edit-availed-product-dialog 
    *ngIf="isEditProductVisible" 
    [product]="product"
    [visible]="isEditProductVisible"
    [stateIndex]="activeIndex"
    (hideEditProduct)="hideEditProduct($event)"
    (showConfirmProduct)="showConfirmProduct($event)">
</edit-availed-product-dialog>

<edit-availed-product-confirm
    *ngIf="isEditConfirmVisible"
    [product]="product"
    [commerceId]="commerceId"
    (hideConfirmProduct)="hideConfirmProduct($event)"
    (backToDialog)="backToDialog($event)"
    [visible]="isEditConfirmVisible">
</edit-availed-product-confirm>
